import { render } from "./Shareholderbasic.vue?vue&type=template&id=1c428f40&scoped=true&ts=true"
import script from "./Shareholderbasic.vue?vue&type=script&lang=ts"
export * from "./Shareholderbasic.vue?vue&type=script&lang=ts"

import "./Shareholderbasic.vue?vue&type=style&index=0&id=1c428f40&scoped=true&lang=css"
import "./Shareholderbasic.vue?vue&type=style&index=1&id=1c428f40&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c428f40"]])

export default __exports__